<template>
    <main class="app-home">
        <browser-open-guide v-if="showBrowserGuide" :platform="browserGuidePlatform"/>
        <section v-else-if="bindingSuccess" class="binding-page binding-success">
            <div class="binding-shell">
                <!--                <div class="binding-brand">一亩三分&爆店卡</div>-->
                <div class="binding-card binding-success-card">
                    <span class="binding-result-icon"><a-icon type="check"/></span>
                    <h1>绑定成功</h1>
                    <p>已绑定至 {{ bindingSuccess.merchantName }} · {{ bindingSuccess.storeName }}</p>
                    <small v-if="bindingSuccess.merchantCreated">商户和门店已创建，后续可在商户后台完善页面配置。</small>
                    <van-button block type="primary" class="binding-primary" @click="load">
                        进入商户页面
                    </van-button>
                </div>
            </div>
        </section>
        <section v-else-if="unbound" class="binding-page">
            <div class="binding-shell">
                <img src="@/asstes/logo2.png" style="height: 70px"/>

                <div class="binding-card">
                    <span class="binding-state">当前卡片尚未绑定</span>
                    <p>输入商户号，将卡片关联到指定门店。</p>
                    <div class="binding-divider"></div>
                    <label class="binding-label">商户号（手机号）</label>
                    <div class="binding-inline">
                        <input v-model.trim="bindingForm.merchantNo" inputmode="numeric" maxlength="11"
                               placeholder="请输入11位商户号" @input="resetMerchantLookup">
                        <van-button type="primary" :loading="bindingLoading" @click="lookupBindingMerchant">查询
                        </van-button>
                    </div>

                    <template v-if="merchantLookup && merchantLookup.exists">
                        <div class="merchant-found">
                            <a-icon type="shop"/>
                            <div><small>已找到商户</small><strong>{{ merchantLookup.merchantName }}</strong></div>
                        </div>
                        <template v-if="merchantLookup.stores.length">
                            <label class="binding-label">选择门店</label>
                            <div class="store-select">
                                <input v-model.trim="storeKeyword" placeholder="输入门店名查询"
                                       @focus="storeOptionsVisible = true" @input="clearSelectedStore">
                                <div v-if="storeOptionsVisible" class="store-options">
                                    <button v-for="store in filteredBindingStores" :key="store.id" type="button"
                                            :class="{selected: bindingForm.storeId === store.id}"
                                            @click="selectBindingStore(store)">
                                        {{ store.storeName }}
                                        <a-icon v-if="bindingForm.storeId === store.id" type="check"/>
                                    </button>
                                    <span v-if="!filteredBindingStores.length">未找到匹配门店</span>
                                </div>
                            </div>
                            <van-button block type="primary" class="binding-primary"
                                        :loading="bindingLoading" @click="bindExistingMerchant">
                                确认绑定门店
                            </van-button>
                        </template>
                        <div v-else class="binding-notice">该商户暂无可绑定门店，请先在商户后台创建门店。</div>
                    </template>

                    <template v-else-if="merchantLookup && !merchantLookup.exists">
                        <div class="binding-notice">未查询到该商户号，可直接创建商户和首家门店。</div>
                        <label class="binding-label">商户名</label>
                        <input v-model.trim="bindingForm.merchantName" maxlength="100" placeholder="请输入商户名">
                        <label class="binding-label">门店名</label>
                        <input v-model.trim="bindingForm.storeName" maxlength="100" placeholder="请输入门店名">
                        <van-button block type="primary" class="binding-primary"
                                    :loading="bindingLoading" @click="createMerchantAndBind">
                            创建商户并绑定
                        </van-button>
                    </template>
                </div>
            </div>
        </section>
        <section v-else-if="showPromoPage">
            <img src="@/asstes/index.png" style="width: 100%" @click="openWechatMiniProgramHome"/>
        </section>


        <div v-else-if="loadError" class="load-error">
            <a-icon type="disconnect"/>
            <strong>无法打开页面</strong>
            <span>{{ loadError }}</span>
        </div>
        <a-spin v-else :spinning="loading">
            <h5-page-preview
                    :config="pageConfig"
                    :interactive="true"
                    @action="handleAction"
                    @open-mini-program-claim="openWechatMiniProgramClaim"
            />
        </a-spin>
        <van-popup v-if="!showBrowserGuide"
                   v-model="videoPopupVisible"
                   position="bottom"
                   round
                   closeable
                   safe-area-inset-bottom
                   class="video-share-popup"
        >
            <div class="video-share-content">
                <h2>{{ sharePopupTitle }}</h2>
                <div
                        v-if="isReviewType(currentShareVideo.itemType) && reviewTopics.length"
                        class="review-topic-section"
                >
                    <div class="review-topic-heading">
                        <strong>评价主题</strong>
                        <span>点击主题切换评价文案</span>
                    </div>
                    <div class="review-topic-cards">
                        <button
                                v-for="topic in visibleReviewTopics"
                                :key="topic.id"
                                type="button"
                                :class="[
                                    'review-topic-card',
                                    {active: currentShareVideo.topicId === topic.id}
                                ]"
                                :disabled="videoShareLoading"
                                @click="selectReviewTopic(topic)"
                        >
                            <span>{{ topic.topicName }}</span>
                            <small>{{ reviewTopicTypeLabel(topic.topicType) }}</small>
                            <em v-if="topic.featured">主推</em>
                        </button>
                    </div>
                    <button
                            v-if="reviewTopics.length > 6"
                            type="button"
                            class="review-topic-toggle"
                            @click="reviewTopicsExpanded = !reviewTopicsExpanded"
                    >
                        {{ reviewTopicsExpanded ? '收起' : `展开更多（${reviewTopics.length - 6}）` }}
                        <span>{{ reviewTopicsExpanded ? '⌃' : '⌄' }}</span>
                    </button>
                </div>
                <div class="share-copy-card">
                    <div class="share-section-heading">
                        <strong>{{ shareTextLabel }}</strong>
                        <van-button
                                v-if="!isReviewType(currentShareVideo.itemType)"
                                size="mini"
                                plain
                                type="primary"
                                @click="copyShareText"
                        >
                            复制
                        </van-button>
                    </div>
                    <p :class="{'is-exhausted': currentShareVideo.reviewExhausted}">
                        {{ currentShareVideo.reviewExhausted ? 'AI生成次数已用完' : shareText }}
                    </p>
                    <div
                            v-if="isReviewType(currentShareVideo.itemType) && !currentShareVideo.reviewExhausted"
                            class="share-copy-footer"
                    >
                        <a
                                href="#"
                                :class="{disabled: videoShareLoading}"
                                @click.prevent="replaceReview"
                        >
                            {{ videoShareLoading ? '正在更换' : '换一换' }}
                        </a>
                    </div>
                </div>
                <div v-if="showShareVideo" class="share-video-card">
                    <video
                            v-if="currentShareVideo.videoUrl"
                            :src="currentShareVideo.videoUrl"
                            controls
                            playsinline
                            preload="metadata"
                    />
                    <van-button
                            block
                            plain
                            round
                            type="primary"
                            @click="saveShareVideoToLocal"
                    >
                        下载视频
                    </van-button>
                </div>
                <div
                        v-if="isReviewType(currentShareVideo.itemType)"
                        class="review-actions"
                >
                    <div class="review-action-guide">
                        <strong>操作提示：</strong>
                        {{
                        currentShareVideo.reviewExhausted
                            ? `AI生成次数已用完，仍可直接${shareOpenButtonText}`
                            : `先点击复制，再${shareOpenButtonText}，粘贴评价文案`
                        }}
                    </div>
                    <div class="review-secondary-actions">
                        <van-button
                                v-if="!currentShareVideo.reviewExhausted"
                                round
                                type="primary"
                                color="#2878df"
                                class="review-action-button"
                                @click="copyShareText"
                        >
                            复制
                        </van-button>
                        <van-button
                                round
                                type="primary"
                                :color="shareButtonColor"
                                class="review-action-button"
                                :class="{ 'meituan-btn': currentShareVideo.itemType === 'MEITUAN_REVIEW' }"
                                @click="openShareTarget"
                        >
                            {{ shareOpenButtonText }}
                        </van-button>
                    </div>
                </div>
                <van-button
                        v-else
                        block
                        round
                        type="primary"
                        :color="shareButtonColor"
                        class="open-wechat-button"
                        @click="openShareTarget"
                >
                    {{ shareOpenButtonText }}
                </van-button>
            </div>
        </van-popup>
    </main>
</template>

<script>
import {Button, Popup, Toast} from 'vant';
import 'vant/lib/button/style';
import 'vant/lib/popup/style';
import 'vant/lib/toast/style';
import H5PagePreview from '../../components/app/H5PagePreview.vue';
import BrowserOpenGuide from './BrowserOpenGuide.vue';
import {
    bindPlateToStore,
    createDouyinPublishSchema,
    createMerchantAndBindPlate,
    drawReviewContent,
    drawShareContent,
    getPublicH5Page,
    getPublicReviewTopics,
    getShareContentDownloadUrl,
    lookupMerchantForBinding,
    markReviewUsed,
    createWechatMiniProgramScheme,
    createWechatMiniProgramClaimScheme,
    createWechatMiniProgramHomeScheme
} from '../../api/h5Page';

export default {
    name: 'AppHome',
    components: {
        H5PagePreview,
        BrowserOpenGuide,
        VanButton: Button,
        VanPopup: Popup
    },
    data() {
        return {
            loading: false,
            loadError: '',
            showPromoPage: false,
            unbound: false,
            bindingLoading: false,
            bindingSuccess: null,
            merchantLookup: null,
            storeKeyword: '',
            storeOptionsVisible: false,
            bindingForm: {
                merchantNo: '',
                storeId: '',
                merchantName: '',
                storeName: ''
            },
            pageConfig: this.emptyConfig(),
            videoPopupVisible: false,
            videoShareLoading: false,
            reviewTopics: [],
            reviewTopicsExpanded: false,
            currentShareVideo: {
                id: '',
                title: '',
                content: '',
                videoUrl: '',
                itemType: '',
                targetUrl: '',
                appTargetUrl: '',
                reviewCounted: false,
                topicId: '',
                topicName: '',
                reviewExhausted: false
            }
        };
    },
    created() {
        if (!this.showBrowserGuide) this.load();
    },
    methods: {
        async load() {
            const plateNo = String(this.$route.query.sn || '').trim();
            if (!plateNo) {
                // 未携带码牌编号时展示产品宣传首页，不请求门店配置接口。
                this.showPromoPage = true;
                this.loadError = '';
                return;
            }
            this.loading = true;
            this.loadError = '';
            this.showPromoPage = false;
            this.unbound = false;
            this.bindingSuccess = null;
            try {
                this.pageConfig = await getPublicH5Page(plateNo, true);
                await this.openRequestedDouyinAction();
                this.openRequestedXiaohongshu();
            } catch (error) {
                if (error.code === 404 || (error.message || '').includes('码牌不存在或尚未绑定门店')) {
                    this.unbound = true;
                } else {
                    this.loadError = error.message || '页面加载失败';
                }
            } finally {
                this.loading = false;
            }
        },
        scrollToPromoDetail() {
            // 主按钮平滑定位到玩法说明，保持默认宣传页的浏览路径完整。
            const detail = this.$refs.promoDetail;
            if (detail) detail.scrollIntoView({behavior: 'smooth', block: 'start'});
        },
        resetMerchantLookup() {
            this.merchantLookup = null;
            this.bindingForm.storeId = '';
            this.storeKeyword = '';
            this.storeOptionsVisible = false;
        },
        validateMerchantNo() {
            if (!/^1\d{10}$/.test(this.bindingForm.merchantNo)) {
                Toast('请输入正确的11位手机号商户号');
                return false;
            }
            return true;
        },
        async lookupBindingMerchant() {
            if (!this.validateMerchantNo() || this.bindingLoading) return;
            this.bindingLoading = true;
            try {
                this.merchantLookup = await lookupMerchantForBinding(this.bindingForm.merchantNo);
                this.bindingForm.storeId = '';
                this.storeKeyword = '';
                if (this.merchantLookup.stores && this.merchantLookup.stores.length === 1) {
                    this.selectBindingStore(this.merchantLookup.stores[0]);
                } else {
                    this.storeOptionsVisible = Boolean(this.merchantLookup.stores.length);
                }
            } catch (error) {
                Toast.fail(error.message || '商户查询失败');
            } finally {
                this.bindingLoading = false;
            }
        },
        selectBindingStore(store) {
            this.bindingForm.storeId = store.id;
            this.storeKeyword = store.storeName;
            this.storeOptionsVisible = false;
        },
        clearSelectedStore() {
            this.bindingForm.storeId = '';
            this.storeOptionsVisible = true;
        },
        async bindExistingMerchant() {
            if (!this.bindingForm.storeId) {
                Toast('请选择要绑定的门店');
                return;
            }
            await this.submitBinding(() => bindPlateToStore({
                plateNo: String(this.$route.query.sn || '').trim(),
                merchantNo: this.bindingForm.merchantNo,
                storeId: this.bindingForm.storeId
            }));
        },
        async createMerchantAndBind() {
            if (!this.bindingForm.merchantName || !this.bindingForm.storeName) {
                Toast('请填写商户名和门店名');
                return;
            }
            await this.submitBinding(() => createMerchantAndBindPlate({
                plateNo: String(this.$route.query.sn || '').trim(),
                merchantNo: this.bindingForm.merchantNo,
                merchantName: this.bindingForm.merchantName,
                storeName: this.bindingForm.storeName
            }));
        },
        async submitBinding(request) {
            if (this.bindingLoading) return;
            this.bindingLoading = true;
            try {
                this.bindingSuccess = await request();
                this.unbound = false;
            } catch (error) {
                Toast.fail(error.message || '码牌绑定失败');
            } finally {
                this.bindingLoading = false;
            }
        },
        async handleAction(item) {
            const params = item.params || {};
            if (!this.isDouyinType(item.itemType)) {
                // 用户切换到其他平台时清除抖音的一次性恢复标记。
                this.clearDouyinActionResume();
            }
            if (item.itemType !== 'XIAOHONGSHU_PLANTING') {
                // 用户切换到其他平台时清除小红书的一次性恢复标记。
                this.clearXiaohongshuResume();
            }
            const requiresExternalBrowser = this.isDouyinType(item.itemType)
                || item.itemType === 'XIAOHONGSHU_PLANTING';
            if (requiresExternalBrowser && this.isRestrictedInAppBrowser()) {
                if (this.isDouyinType(item.itemType)) {
                    this.markDouyinActionForBrowserResume(item.itemType);
                    const resumeUrl = window.location.href;
                    this.clearDouyinActionResume();
                    await this.openBrowserGuide('抖音', resumeUrl);
                    return;
                }
                if (item.itemType === 'XIAOHONGSHU_PLANTING') {
                    this.markXiaohongshuForBrowserResume();
                    const resumeUrl = window.location.href;
                    this.clearXiaohongshuResume();
                    await this.openBrowserGuide('小红书', resumeUrl);
                    return;
                }
            }
            if (item.itemType === 'STORE_WIFI') {
                await this.openWechatMiniProgram('wifi');
                return;
            }
            if (item.itemType === 'STORE_CONTACT') {
                await this.openWechatMiniProgram('contact');
                return;
            }
            if (['WECHAT_CHANNEL_PUBLISH', 'WECHAT_CHANNEL_PROFILE', 'WECHAT_CHANNEL_VIDEO'].includes(item.itemType)) {
                await this.openWechatMiniProgram('channels');
                return;
            }
            if (item.itemType === 'XIAOHONGSHU_PLANTING') {
                this.openXiaohongshuMiniProgram();
                return;
            }
            const actionType = this.resolveActionType(item);
            if (actionType === 'PUBLISH') {
                await this.openPublishPage(item);
                return;
            }
            if (actionType === 'REVIEW') {
                if (!params.targetUrl) return this.missingMerchantLink();
                await this.openReviewPage(item);
                return;
            }
            if (actionType === 'GROUP_BUY') {
                if (!params.targetUrl) return this.missingMerchantLink();
                // 团购卡片不抽取评价文案；抖音在手机端复用后台解析出的原生 POI 地址。
                const targetUrl = this.buildShareTargetUrl(
                    item.itemType,
                    params.targetUrl,
                    params.appTargetUrl
                );
                if (this.isDouyinType(item.itemType) && this.isRestrictedInAppBrowser()) {
                    await this.openBrowserGuide('抖音', targetUrl);
                    return;
                }
                window.location.href = targetUrl;
                return;
            }
            if (actionType === 'LINK') {
                if (!params.targetUrl) return this.missingMerchantLink();
                if (this.isDouyinType(item.itemType) && this.isRestrictedInAppBrowser()) {
                    await this.openBrowserGuide('抖音', params.targetUrl);
                    return;
                }
                window.location.href = params.targetUrl;
                return;
            }
            Toast.fail('暂不支持该功能类型');
        },
        async openPublishPage(item) {
            if (this.videoShareLoading) return;
            const plateNo = String(this.$route.query.sn || '').trim();
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在准备发布内容'});
            try {
                const params = item.params || {};
                const shareContent = await drawShareContent(plateNo);
                if (!shareContent || !shareContent.id || !shareContent.videoUrl) {
                    Toast.clear();
                    Toast.fail('没有可用成品视频，请联系售后处理！');
                    return;
                }
                if (item.itemType === 'DOUYIN_PUBLISH') {
                    // 首页内直接生成抖音投稿参数，不再进入发布中间页。
                    const result = await createDouyinPublishSchema(plateNo, shareContent.id);
                    if (!result || !result.schema) {
                        throw new Error('投稿参数生成失败');
                    }
                    Toast.clear();
                    window.location.href = result.schema;
                    return;
                }
                const publishContent = {
                    id: shareContent.id || '',
                    title: shareContent.title || '',
                    content: shareContent.content || '',
                    merchantTags: shareContent.merchantTags || '',
                    hashtags: shareContent.hashtags || '',
                    videoUrl: shareContent.videoUrl || '',
                    itemType: item.itemType,
                    actionType: this.resolveActionType(item),
                    targetUrl: params.targetUrl || '',
                    plateNo
                };
                window.sessionStorage.setItem(
                    'ai-video-publish-content',
                    JSON.stringify(publishContent)
                );
                Toast.clear();
                await this.$router.push({
                    path: '/app/publish',
                    query: {sn: plateNo, type: item.itemType}
                });
            } catch (error) {
                Toast.clear();
                const errorMessage = String(error.message || '');
                if (errorMessage.includes('暂无可分享的视频')
                    || errorMessage.includes('没有可用成品视频')) {
                    Toast.fail('没有可用成品视频，请联系售后处理！');
                    return;
                }
                Toast.fail(errorMessage || '发布内容准备失败');
            } finally {
                this.videoShareLoading = false;
            }
        },
        async openWechatMiniProgram(action) {
            if (this.videoShareLoading) return;
            const plateNo = String(this.$route.query.sn || '').trim();
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在加载'});
            try {
                const result = await createWechatMiniProgramScheme(plateNo, action);
                Toast.clear();
                if (!result || !result.openlink) throw new Error('server 未返回小程序入口');
                window.location.href = result.openlink;
            } catch (error) {
                Toast.clear();
                Toast.fail(error.message || '微信小程序打开失败');
            } finally {
                this.videoShareLoading = false;
            }
        },
        async openWechatMiniProgramHome() {
            if (this.videoShareLoading) return;
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在加载'});
            try {
                const result = await createWechatMiniProgramHomeScheme();
                Toast.clear();
                if (!result || !result.openlink) throw new Error('server 未返回小程序入口');
                window.location.href = result.openlink;
            } catch (error) {
                Toast.clear();
                Toast.fail(error.message || '微信小程序打开失败');
            } finally {
                this.videoShareLoading = false;
            }
        },
        async openWechatMiniProgramClaim() {
            if (this.videoShareLoading) return;
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在加载'});
            try {
                const result = await createWechatMiniProgramClaimScheme();
                Toast.clear();
                if (!result || !result.openlink) throw new Error('server 未返回小程序入口');
                window.location.href = result.openlink;
            } catch (error) {
                Toast.clear();
                Toast.fail(error.message || '微信小程序打开失败');
            } finally {
                this.videoShareLoading = false;
            }
        },
        openXiaohongshuMiniProgram() {
            const plateNo = String(this.$route.query.sn || '').trim();
            const appId = String(this.pageConfig.xiaohongshuAppId || '').trim();
            if (!plateNo || !appId) {
                Toast.fail('未配置小红书小程序');
                return;
            }
            // 点击时同步跳转协议地址，不经过异步接口和 URL Link 中间页。
            window.location.href = `xhsdiscover://miniapp/${appId}/pages/index/index`
                + `?sn=${encodeURIComponent(plateNo)}`;
        },
        async openReviewPage(item) {
            const plateNo = String(this.$route.query.sn || '').trim();
            const params = item.params || {};
            const reviewContent = {
                itemType: item.itemType,
                actionType: this.resolveActionType(item),
                targetUrl: params.targetUrl || '',
                appTargetUrl: params.appTargetUrl || '',
                description: String(item.description || '').trim(),
                plateNo
            };
            window.sessionStorage.setItem(
                'ai-video-review-content',
                JSON.stringify(reviewContent)
            );
            await this.$router.push({
                path: '/app/review',
                query: {sn: plateNo, type: item.itemType}
            });
        },
        async prepareReview(item) {
            const plateNo = String(this.$route.query.sn || '').trim();
            let defaultTopic = null;
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在读取评价主题'});
            try {
                this.reviewTopics = await getPublicReviewTopics(plateNo);
                this.reviewTopicsExpanded = false;
                if (this.reviewTopics.length) {
                    defaultTopic = this.reviewTopics.find(topic => topic.featured)
                        || this.reviewTopics[0];
                }
            } catch (error) {
                Toast.clear();
                Toast.fail(error.message || '评价主题读取失败');
                return;
            } finally {
                this.videoShareLoading = false;
            }
            Toast.clear();
            if (defaultTopic) {
                // 进入评价弹窗时默认使用主推主题，减少一次选择步骤。
                await this.showSharePopup(item, defaultTopic.id, defaultTopic.topicName);
                return;
            }
            // 尚未配置主题的旧商户继续使用历史未分类评价。
            await this.showSharePopup(item, null, '');
        },
        async selectReviewTopic(topic) {
            if (this.currentShareVideo.topicId === topic.id || this.videoShareLoading) return;
            const current = this.currentShareVideo;
            await this.showSharePopup({
                itemType: current.itemType,
                params: {
                    targetUrl: current.targetUrl,
                    appTargetUrl: current.appTargetUrl
                }
            }, topic.id, topic.topicName);
        },
        async showSharePopup(item, topicId, topicName, excludeReviewId) {
            if (this.videoShareLoading) return;
            const plateNo = String(this.$route.query.sn || '').trim();
            this.videoShareLoading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '正在生成文案'});
            try {
                const params = item.params || {};
                // 评价使用独立评价库，不再消耗最终视频及其发布文案。
                const result = await drawReviewContent(
                    plateNo,
                    item.itemType,
                    item.itemType === 'XIAOHONGSHU_PLANTING' ? 'recommend' : 'review',
                    topicId || undefined,
                    excludeReviewId || undefined
                );
                const shareContent = result || {};
                this.currentShareVideo = {
                    id: shareContent.id || '',
                    title: shareContent.title || '',
                    content: shareContent.content || '',
                    videoUrl: shareContent.videoUrl || '',
                    itemType: item.itemType,
                    targetUrl: params.targetUrl || '',
                    appTargetUrl: params.appTargetUrl || '',
                    reviewCounted: false,
                    topicId: topicId || '',
                    topicName: topicName || '',
                    reviewExhausted: !shareContent.id || !String(shareContent.content || '').trim()
                };
                Toast.clear();
                this.videoPopupVisible = true;
            } catch (error) {
                Toast.clear();
                Toast.fail(error.message || '评价文案获取失败');
            } finally {
                this.videoShareLoading = false;
            }
        },
        async copyShareText() {
            try {
                await this.copyTextToClipboard(this.shareText);
                Toast.success('内容已复制');
            } catch (error) {
                Toast.fail('复制失败，请长按内容复制');
            }
        },
        saveShareVideoToLocal() {
            if (!this.currentShareVideo.id) return;
            const plateNo = String(this.$route.query.sn || '').trim();
            const anchor = document.createElement('a');
            anchor.href = getShareContentDownloadUrl(plateNo, this.currentShareVideo.id);
            anchor.download = `${this.videoTitle || '分享视频'}.mp4`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            Toast.success('视频已开始下载');
        },
        async copyTextToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return;
            }
            this.copyTextFallback(text);
        },
        copyTextFallback(text) {
            const input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', 'readonly');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            let copied = false;
            try {
                copied = document.execCommand('copy');
            } finally {
                document.body.removeChild(input);
            }
            if (!copied) throw new Error('copy failed');
        },
        async replaceReview() {
            const current = this.currentShareVideo;
            await this.showSharePopup({
                itemType: current.itemType,
                params: {
                    targetUrl: current.targetUrl,
                    appTargetUrl: current.appTargetUrl
                }
            }, current.topicId, current.topicName, current.id);
        },
        async openShareTarget() {
            const itemType = this.currentShareVideo.itemType;
            if (this.isReviewType(itemType) && this.currentShareVideo.id
                && !this.currentShareVideo.reviewCounted) {
                const plateNo = String(this.$route.query.sn || '').trim();
                try {
                    // 评价只在用户明确点击打开平台时计数，展示、复制和换一条均不计数。
                    await markReviewUsed(
                        plateNo,
                        this.currentShareVideo.id,
                        itemType,
                        itemType === 'XIAOHONGSHU_PLANTING' ? 'recommend' : 'review'
                    );
                    this.currentShareVideo.reviewCounted = true;
                } catch (error) {
                    Toast.fail(error.message || '评价使用次数记录失败，请重试');
                    return;
                }
            }
            if (itemType === 'DOUYIN_REVIEW' && this.isRestrictedInAppBrowser()) {
                this.markDouyinActionForBrowserResume(itemType);
                const resumeUrl = window.location.href;
                this.clearDouyinActionResume();
                await this.openBrowserGuide('抖音', resumeUrl);
                return;
            }
            const configuredUrl = this.currentShareVideo.targetUrl
                || this.platformAppUrl(itemType);
            const targetUrl = this.buildShareTargetUrl(
                itemType,
                configuredUrl,
                this.currentShareVideo.appTargetUrl
            );
            if (!targetUrl) return this.missingMerchantLink();
            window.location.href = targetUrl;
        },
        buildShareTargetUrl(itemType, targetUrl, appTargetUrl) {
            const normalizedUrl = this.extractFirstHttpUrl(targetUrl);
            if (['DOUYIN_REVIEW', 'DOUYIN_GROUP_BUY'].includes(itemType)
                && this.isMobileBrowser()) {
                // 手机端优先直达抖音原生 POI 团购页，避免网页口令覆盖剪贴板。
                return String(appTargetUrl || '').trim() || normalizedUrl;
            }
            return normalizedUrl;
        },
        extractFirstHttpUrl(targetUrl) {
            const normalizedUrl = String(targetUrl || '').trim();
            const httpUrlMatch = normalizedUrl.match(/^https?:\/\/\S+/i);
            return httpUrlMatch ? httpUrlMatch[0] : normalizedUrl;
        },
        isMobileBrowser() {
            return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
        },
        isRestrictedInAppBrowser() {
            return /MicroMessenger|QQ\/|Weibo|DingTalk|AlipayClient/i.test(
                navigator.userAgent || ''
            );
        },
        async openBrowserGuide(platform, target) {
            const resumeUrl = new URL(target, window.location.href);
            if (resumeUrl.origin === window.location.origin && resumeUrl.pathname === '/app') {
                // 微信内在首页地址显示引导，系统浏览器打开同一地址即可直接恢复首页动作。
                const query = {};
                resumeUrl.searchParams.forEach((value, key) => {
                    query[key] = value;
                });
                await this.$router.push({path: '/app', query});
                return;
            }
            await this.$router.push({
                path: '/app/browser-open-guide',
                query: {platform, target}
            });
        },
        markDouyinActionForBrowserResume(itemType) {
            const url = new URL(window.location.href);
            url.searchParams.set('resumeDouyin', String(itemType || '').trim());
            // 保留 Vue Router 写入的 history state，否则微信外跳返回时可能失去正确历史位置。
            window.history.replaceState(window.history.state, '', url.toString());
        },
        clearDouyinActionResume() {
            const url = new URL(window.location.href);
            if (!url.searchParams.has('resumeDouyin')) return;
            // 直接替换当前历史项，返回首页时不会再次触发已消费的抖音动作。
            url.searchParams.delete('resumeDouyin');
            window.history.replaceState(window.history.state, '', url.toString());
        },
        markXiaohongshuForBrowserResume() {
            const url = new URL(window.location.href);
            url.searchParams.set('resumeXiaohongshu', '1');
            // 微信选择在浏览器打开时会沿用当前地址，系统浏览器据此继续本次小红书跳转。
            window.history.replaceState(window.history.state, '', url.toString());
        },
        clearXiaohongshuResume() {
            const url = new URL(window.location.href);
            if (!url.searchParams.has('resumeXiaohongshu')) return;
            // 恢复动作只消费一次，防止用户返回首页后重复拉起小红书。
            url.searchParams.delete('resumeXiaohongshu');
            window.history.replaceState(window.history.state, '', url.toString());
        },
        async openRequestedDouyinAction() {
            const itemType = String(this.$route.query.resumeDouyin || '').trim();
            if (!this.isDouyinType(itemType)) return;
            // 恢复标记只允许消费一次，必须在执行动作前从首页历史记录中移除。
            this.clearDouyinActionResume();
            const groups = Array.isArray(this.pageConfig.groups) ? this.pageConfig.groups : [];
            const items = groups.reduce((result, group) => (
                result.concat(Array.isArray(group.items) ? group.items : [])
            ), []);
            const actionItem = items.find(item => item.itemType === itemType);
            if (actionItem) {
                // 系统浏览器回到首页后复用正常入口逻辑，发布抖音时此处才调用投稿接口。
                await this.handleAction(actionItem);
            }
        },
        openRequestedXiaohongshu() {
            if (this.$route.query.resumeXiaohongshu !== '1') return;
            // 先清除一次性标记，再尝试从系统浏览器直接拉起小红书小程序。
            this.clearXiaohongshuResume();
            this.openXiaohongshuMiniProgram();
        },
        platformAppUrl(itemType) {
            return {
                DOUYIN_PUBLISH: 'snssdk1128://',
                WECHAT_CHANNEL_PUBLISH: 'weixin://'
            }[itemType] || '';
        },
        isPublishType(itemType) {
            return ['DOUYIN_PUBLISH', 'WECHAT_CHANNEL_PUBLISH'].includes(itemType);
        },
        isReviewType(itemType) {
            return ['DOUYIN_REVIEW', 'MEITUAN_REVIEW', 'DIANPING_REVIEW', 'GAODE_REVIEW'].includes(itemType);
        },
        isDouyinType(itemType) {
            return String(itemType || '').startsWith('DOUYIN_');
        },
        resolveActionType(item) {
            const configuredType = String((item || {}).actionType || '').trim();
            return ['LINK', 'REVIEW', 'GROUP_BUY', 'PUBLISH'].includes(configuredType)
                ? configuredType
                : '';
        },
        reviewTopicTypeLabel(topicType) {
            return {
                STORE_SIGNATURE: '店内招牌',
                GROUP_BUY_PACKAGE: '团购套餐',
                EXCELLENT_SERVICE: '服务超赞'
            }[topicType] || '评价主题';
        },
        missingMerchantLink() {
            Toast.fail('商户暂未配置该功能的跳转地址');
        },
        emptyConfig() {
            return {
                merchantName: '',
                storeName: '',
                headerImageUrl: '',
                pageTitle: '',
                pageSubtitle: '',
                noticeEnabled: false,
                noticeText: '',
                wifiEnabled: false,
                wifiName: '',
                wifiPassword: '',
                backgroundUrl: '',
                groups: []
            };
        }
    },
    computed: {
        showBrowserGuide() {
            return this.isRestrictedInAppBrowser()
                && (Boolean(this.$route.query.resumeDouyin) || this.$route.query.resumeXiaohongshu === '1');
        },
        browserGuidePlatform() {
            return this.$route.query.resumeXiaohongshu === '1' ? '小红书' : '抖音';
        },
        filteredBindingStores() {
            if (!this.merchantLookup || !Array.isArray(this.merchantLookup.stores)) return [];
            const keyword = this.storeKeyword.trim().toLowerCase();
            return this.merchantLookup.stores.filter(store => (
                !keyword || store.storeName.toLowerCase().includes(keyword)
            ));
        },
        visibleReviewTopics() {
            return this.reviewTopicsExpanded ? this.reviewTopics : this.reviewTopics.slice(0, 6);
        },
        videoTitle() {
            return String((this.currentShareVideo || {}).title || '').trim();
        },
        shareText() {
            const content = String((this.currentShareVideo || {}).content || '').trim();
            if (this.isReviewType(this.currentShareVideo.itemType)) {
                return content || this.videoTitle;
            }
            return this.videoTitle || content;
        },
        shareTextLabel() {
            return this.isReviewType(this.currentShareVideo.itemType)
                ? '评价文案'
                : '视频标题';
        },
        showShareVideo() {
            return this.isPublishType(this.currentShareVideo.itemType)
                && Boolean(this.currentShareVideo.videoUrl);
        },
        sharePopupTitle() {
            return this.isReviewType(this.currentShareVideo.itemType)
                ? '发布评价'
                : '视频发布';
        },
        shareOpenButtonText() {
            return {
                DOUYIN_PUBLISH: '打开抖音',
                WECHAT_CHANNEL_PUBLISH: '打开视频号',
                DOUYIN_REVIEW: '打开抖音',
                MEITUAN_REVIEW: '打开美团',
                DIANPING_REVIEW: '打开大众点评',
                GAODE_REVIEW: '打开高德地图'
            }[this.currentShareVideo.itemType] || '打开';
        },
        shareButtonColor() {
            return {
                WECHAT_CHANNEL_PUBLISH: '#07c160',
                MEITUAN_REVIEW: '#ffdf00',
                DIANPING_REVIEW: '#ff6a00',
                GAODE_REVIEW: '#1677ff'
            }[this.currentShareVideo.itemType] || '#111827';
        }
    }
};
</script>

<style scoped>
.app-home {
    min-height: 100vh;
    background: #f5f7fb;
}

.app-home > .ant-spin-nested-loading {
    min-height: 100vh;
}

.promo-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    color: #0d1b2e;
    background: #ffffff;
}

.promo-shell {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 22px 18px 44px;
}

.promo-brand {
    display: flex;
    height: 48px;
    align-items: center;
}

.promo-brand img {
    display: block;
    width: 164px;
    height: auto;
}

.promo-copy {
    padding: 30px 5px 20px;
}

.promo-kicker {
    margin: 0 0 9px;
    color: #079aa2;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .16em;
}

.promo-copy h1 {
    margin: 0;
    color: #0b1728;
    font-size: clamp(38px, 11.5vw, 50px);
    font-weight: 900;
    line-height: 1.05;
    letter-spacing: -.045em;
}

.promo-copy h2 {
    margin: 15px 0 0;
    color: #0d1b2e;
    font-size: clamp(25px, 7vw, 31px);
    font-weight: 800;
    line-height: 1.22;
    letter-spacing: -.025em;
}

.promo-description {
    max-width: 350px;
    margin: 12px 0 0;
    color: #687386;
    font-size: 15px;
    line-height: 1.7;
}

.promo-hero {
    position: relative;
    height: 292px;
    overflow: hidden;
    border-radius: 30px;
    background: #edf9f8;
    box-shadow: 0 22px 46px rgba(14, 49, 69, .16);
}

.promo-hero img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 43%;
}

.promo-benefits {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin: -22px 12px 0;
    padding: 19px 5px 17px;
    border: 1px solid rgba(217, 228, 232, .85);
    border-radius: 24px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 14px 34px rgba(32, 73, 90, .12);
}

.promo-benefit {
    display: flex;
    min-width: 0;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 0 7px;
}

.promo-benefit + .promo-benefit {
    border-left: 1px solid #e5ebee;
}

.promo-benefit-icon {
    display: grid;
    width: 40px;
    height: 40px;
    place-items: center;
    border-radius: 14px;
    color: #087b92;
    background: #e8fbf7;
    font-size: 20px;
}

.promo-benefit:nth-child(2) .promo-benefit-icon {
    color: #286fa0;
    background: #edf7ff;
}

.promo-benefit:nth-child(3) .promo-benefit-icon {
    color: #617b13;
    background: #f7fbdc;
}

.promo-benefit strong {
    overflow: hidden;
    max-width: 100%;
    color: #263244;
    font-size: 13px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.promo-primary {
    display: flex;
    width: calc(100% - 24px);
    height: 58px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 22px 12px 0;
    border: 0;
    border-radius: 999px;
    outline: none;
    color: #061c2e;
    background: linear-gradient(100deg, #09d6ec 0%, #42e5c7 52%, #e8f66a 100%);
    box-shadow: 0 13px 28px rgba(26, 210, 192, .25);
    font-size: 20px;
    font-weight: 800;
    letter-spacing: .03em;
}

.promo-primary:active {
    transform: translateY(1px);
    box-shadow: 0 7px 18px rgba(26, 210, 192, .23);
}

.promo-assurance {
    margin: 12px 0 0;
    color: #7a8492;
    font-size: 13px;
    letter-spacing: .09em;
    text-align: center;
}

.promo-detail {
    scroll-margin-top: 20px;
    margin: 52px 0 0;
    padding: 30px 24px 28px;
    border: 1px solid #e9eef0;
    border-radius: 26px;
    background: #f7faf9;
}

.promo-detail-eyebrow {
    margin: 0 0 8px;
    color: #079aa2;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .12em;
}

.promo-detail h3 {
    margin: 0;
    color: #152236;
    font-size: 23px;
    line-height: 1.35;
}

.promo-detail > p:not(.promo-detail-eyebrow) {
    margin: 14px 0 0;
    color: #687386;
    font-size: 14px;
    line-height: 1.75;
}

.promo-steps {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    margin-top: 24px;
    color: #597078;
    font-size: 12px;
}

.promo-steps span {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 6px;
    text-align: center;
}

.promo-steps em {
    display: grid;
    width: 30px;
    height: 30px;
    place-items: center;
    border-radius: 50%;
    color: #064b5a;
    background: #c9f7ed;
    font-style: normal;
    font-weight: 800;
}

.promo-steps > .anticon {
    color: #aebdc0;
    font-size: 11px;
}

.promo-glow {
    position: absolute;
    z-index: 0;
    border-radius: 50%;
    pointer-events: none;
    filter: blur(2px);
}

.promo-glow-top {
    top: -130px;
    right: -150px;
    width: 330px;
    height: 330px;
    background: radial-gradient(circle at 35% 65%, rgba(238, 248, 100, .78), rgba(51, 230, 206, .36) 45%, rgba(0, 210, 242, 0) 72%);
}

.promo-glow-bottom {
    bottom: 220px;
    left: -170px;
    width: 320px;
    height: 320px;
    background: radial-gradient(circle, rgba(24, 220, 236, .22), rgba(24, 220, 236, 0) 70%);
}

@media (max-width: 360px) {
    .promo-shell {
        padding-right: 14px;
        padding-left: 14px;
    }

    .promo-copy {
        padding-top: 24px;
    }

    .promo-hero {
        height: 270px;
    }

    .promo-benefits {
        margin-right: 6px;
        margin-left: 6px;
    }

    .promo-primary {
        width: calc(100% - 12px);
        margin-right: 6px;
        margin-left: 6px;
    }
}

.binding-page {
    position: fixed;
    z-index: 100;
    inset: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    overflow-y: auto;
    padding: 0 22px 34px;
    background: #fff;
    overscroll-behavior: none;
}

.binding-shell {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding-top: 18px;
}

.binding-brand {
    height: 48px;
    color: #111827;
    font-size: 18px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: .02em;
}

.binding-card {
    max-height: none;
    overflow-y: auto;
    padding: 24px 0 10px;
    border: 0;
    border-radius: 0;
    background: #fff;
    overscroll-behavior: contain;
}

.binding-card h1 {
    margin: 10px 0 0;
    color: #111827;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.35;
}

.binding-card > p {
    margin: 10px 0 0;
    color: #697586;
    font-size: 15px;
    line-height: 1.7;
}

.binding-card > small {
    display: block;
    margin: 12px 0 0;
    color: #6b7280;
    line-height: 1.6;
}

.binding-state {
    display: inline-flex;
    align-items: center;
    height: 28px;
    padding: 0 11px;
    border-radius: 999px;
    color: #176b52;
    background: #eaf8f2;
    font-size: 12px;
    font-weight: 700;
}

.binding-divider {
    height: 1px;
    margin: 26px 0 4px;
    background: #edf1f5;
}

.binding-label {
    display: block;
    margin: 20px 0 9px;
    color: #263244;
    font-size: 13px;
    font-weight: 700;
}

.binding-card input {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    padding: 0 14px;
    border: 1px solid #d9e0ea;
    border-radius: 12px;
    outline: none;
    color: #111827;
    background: #f8fafc;
    font-size: 16px;
    transition: border-color .15s, box-shadow .15s, background .15s;
}

.binding-card input:focus {
    border-color: #1f8f6d;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(31, 143, 109, .1);
}

.binding-inline {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 84px;
    gap: 10px;
}

.binding-inline .van-button {
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: #111827;
}

.merchant-found {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 22px;
    padding: 14px 15px;
    border: 1px solid #dbeee7;
    border-radius: 14px;
    color: #1f8f6d;
    background: #f4fbf8;
}

.merchant-found > .anticon {
    font-size: 22px;
}

.merchant-found div {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.merchant-found small {
    color: #7c8b9c;
}

.merchant-found strong {
    color: #172033;
    font-weight: 700;
}

.store-select {
    position: relative;
}

.store-options {
    position: absolute;
    z-index: 20;
    top: calc(100% + 6px);
    right: 0;
    left: 0;
    max-height: 210px;
    overflow-y: auto;
    padding: 6px;
    border: 1px solid #dfe6ef;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 14px 34px rgba(15, 23, 42, .12);
}

.store-options button {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border: 0;
    border-radius: 10px;
    color: #374151;
    background: transparent;
    text-align: left;
}

.store-options button.selected {
    color: #1f8f6d;
    background: #edf9f4;
}

.store-options > span {
    display: block;
    padding: 16px 10px;
    color: #97a4b4;
    font-size: 13px;
    text-align: center;
}

.binding-notice {
    margin-top: 18px;
    padding: 13px 14px;
    border: 1px solid #f0dfb7;
    border-radius: 12px;
    color: #735b24;
    background: #fffaf0;
    font-size: 13px;
    line-height: 1.6;
}

.binding-primary {
    height: 48px;
    margin-top: 24px;
    border: 0;
    border-radius: 999px;
    background: #111827;
    font-weight: 700;
}

.binding-success-card {
    margin-top: 32px;
    padding-top: 32px;
    text-align: center;
}

.binding-result-icon {
    display: inline-grid;
    width: 42px;
    height: 42px;
    place-items: center;
    border-radius: 50%;
    color: #fff;
    background: #22a06b;
    font-size: 20px;
}

.binding-success-card h1 {
    margin-top: 16px;
}

.binding-success-card > p,
.binding-success-card > small {
    text-align: center;
}

.load-error {
    display: flex;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 32px;
    color: #8b95a5;
    text-align: center;
}

.load-error .anticon {
    color: #b8c0cc;
    font-size: 48px;
}

.load-error strong {
    margin-top: 18px;
    color: #334155;
    font-size: 18px;
}

.load-error span {
    margin-top: 8px;
    font-size: 14px;
}

.review-topic-section {
    margin: 16px 0;
}

.review-topic-heading {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 9px;
}

.review-topic-heading strong {
    color: #334155;
    font-size: 15px;
}

.review-topic-heading span {
    color: #94a3b8;
    font-size: 11px;
}

.review-topic-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    padding: 1px;
}

.review-topic-card {
    position: relative;
    display: flex;
    width: 100%;
    min-width: 0;
    min-height: 62px;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    padding: 10px 13px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #1f2937;
    background: #f8fafc;
    text-align: left;
}

.review-topic-card.active {
    border-color: #7c3aed;
    color: #5b21b6;
    background: #f5f3ff;
    box-shadow: 0 0 0 1px rgba(124, 58, 237, .08);
}

.review-topic-card span {
    font-size: 14px;
    font-weight: 600;
}

.review-topic-card small {
    margin-top: 3px;
    color: #8b95a5;
    font-size: 11px;
}

.review-topic-card em {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 1px 5px;
    border-radius: 999px;
    color: #b45309;
    background: #fef3c7;
    font-size: 9px;
    font-style: normal;
}

.review-topic-toggle {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-top: 10px;
    padding: 8px;
    border: 0;
    color: #6d28d9;
    background: transparent;
    font-size: 13px;
}

.review-topic-toggle span {
    font-size: 15px;
    line-height: 1;
}

.open-wechat-button {
    margin-top: 20px;
}

.review-actions {
    margin-top: 20px;
}

.review-action-guide {
    margin-bottom: 10px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
}

.review-action-guide strong {
    color: #334155;
}

.review-secondary-actions {
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.review-action-button {
    min-width: 0;
    flex: 1;
}

.video-share-popup {
    overflow: hidden;
}

.video-share-content {
    max-height: 88vh;
    overflow-y: auto;
    padding: 26px 18px 22px;
}

.video-share-content h2 {
    margin: 0 0 18px;
    color: #1f2937;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
}

.share-copy-card,
.share-video-card {
    padding: 14px;
    border-radius: 12px;
    background: #f7f8fa;
}

.share-section-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.share-copy-card p {
    margin: 12px 0 0;
    color: #374151;
    font-size: 14px;
    line-height: 1.7;
    white-space: pre-wrap;
    word-break: break-word;
}

.share-copy-card p.is-exhausted {
    color: #9ca3af;
    text-align: center;
}

.share-copy-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.share-copy-footer a {
    color: #2878df;
    font-size: 13px;
    font-weight: 500;
}

.share-copy-footer a.disabled {
    color: #94a3b8;
    pointer-events: none;
}

.share-video-card {
    margin-top: 12px;
}

.share-video-card video {
    display: block;
    width: 100%;
    max-height: 48vh;
    margin-bottom: 12px;
    border-radius: 9px;
    background: #000;
}

@media (min-width: 520px) {
    .app-home {
        width: 430px;
        margin: 0 auto;
        box-shadow: 0 0 50px rgba(25, 48, 83, .12);
    }

    .video-share-popup {
        right: auto;
        left: 50%;
        width: 430px;
        margin-left: -215px;
    }
}


::v-deep .meituan-btn .van-button__text {
    color: #000000 !important;
}

</style>
